import { useEffect, useState } from 'react';

import { ChevronUp } from 'lucide-react';

import { useResponsiveTextTruncation } from '#/common/hooks';
import { truncateText } from '#/utils/helperFunctions';

function FaqList({ faqs, isSending, updateMessages, onFaqStateChange, faqContainerRef }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const maxLength = useResponsiveTextTruncation({ desktopMaxLength: 30 });

  const handleFaqExpand = () => setIsExpanded(!isExpanded);

  const handleUpdateMessages = (question, id) => () => {
    updateMessages(question, id);
    setIsExpanded(false);
  };

  const getDisplayText = question => {
    if (faqs?.length === 1) return question;
    return isExpanded ? question : truncateText(question, maxLength);
  };

  if (!faqs?.length) return null;

  const displayFaqs = isExpanded ? faqs : faqs?.slice(0, 1);
  const hasMoreFaqs = faqs.length > 1;

  useEffect(() => {
    if (onFaqStateChange) {
      onFaqStateChange(isExpanded);
    }
  }, [isExpanded]);

  return (
    <div className={`faq-container ${isExpanded ? 'expanded' : ''}`} ref={faqContainerRef}>
      <ul className={`faqs ${isSending ? 'disable' : ''}`}>
        {displayFaqs?.map(
          ({ question, id }) =>
            question && (
              <li key={id} className="faq" onClick={handleUpdateMessages(question, id)}>
                {getDisplayText(question)}
              </li>
            )
        )}
      </ul>
      {hasMoreFaqs && !isExpanded && (
        <button className="faq" onClick={handleFaqExpand} disabled={isSending}>
          +{faqs.length - 1}
        </button>
      )}
      {hasMoreFaqs && (
        <span
          className={`faq-toggle-btn ${isExpanded ? 'button-rotate' : ''}`}
          onClick={handleFaqExpand}
          disabled={isSending}
        >
          <ChevronUp />
        </span>
      )}
    </div>
  );
}

export default FaqList;
